import script from "./ServiceSupportPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceSupportPage.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__